export default __webpack_public_path__ + "static/media/Icon-help.49b1fab5.svg";